import React, { FC, memo } from 'react';
import { AutoMeteCcpassCallNotice11 } from 'src/api/types';
import { Input, Select } from 'udesk-ui';
import Ellipsis from 'src/components/common/Ellipsis';
import './style.scss';
import UdeskLocales from 'UdeskLocales';

export const AgentTyoeMap = {
    Belong: 1,
    None: 2,
    Email: 3,
};

interface TemplateProps {
    value?: AutoMeteCcpassCallNotice11;
    onChange?: (v?: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange } = props;

    return (
        <div className="calling-robot-config">
            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    <Ellipsis
                        text={
                            /* 任务名称 */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.taskName
                        }
                    />
                </div>
                <div className="massage-push-configuration-row-content">
                    <Input
                        value={value?.name}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                name: e.target.value,
                            })
                        }
                        maxLength={200}
                        placeholder={
                            /* 请输入 */ UdeskLocales['current'].components.massagePushConfiguration
                                .otherPush.components.callingRobotConfig.index.pleaseEnter
                        }
                        style={{ width: 250 }}
                    />
                </div>
            </div>

            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    <Ellipsis
                        text={
                            /* 外呼模板ID */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.outcallTemplateID
                        }
                    />
                </div>
                <div className="massage-push-configuration-row-content">
                    <Input
                        type="number"
                        value={value?.callTemplateId}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                callTemplateId: e.target.value ? Number(e.target.value) : undefined,
                            })
                        }
                        maxLength={200}
                        placeholder={
                            /* 请输入，仅限int */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.pleaseEnterIntOnly
                        }
                        style={{ width: 250 }}
                    />
                </div>
            </div>

            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    <Ellipsis
                        text={
                            /* 外呼机器人定义ID */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.outcallRobotDefinitionID
                        }
                    />
                </div>
                <div className="massage-push-configuration-row-content">
                    <Input
                        type="number"
                        value={value?.robotDefId}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                robotDefId: e.target.value ? Number(e.target.value) : undefined,
                            })
                        }
                        maxLength={200}
                        placeholder={
                            /* 请输入，仅限int */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.pleaseEnterIntOnly
                        }
                        style={{ width: 250 }}
                    />
                </div>
            </div>

            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    <Ellipsis
                        text={
                            /* 主叫号码类型 */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.callingNumberType
                        }
                    />
                </div>
                <div className="massage-push-configuration-row-content">
                    <Select
                        value={value?.spnumberType}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                spnumberType: e,
                            })
                        }
                        options={[
                            {
                                value: 1,
                                label: /* 中继号 */ UdeskLocales['current'].components
                                    .massagePushConfiguration.otherPush.components
                                    .callingRobotConfig.index.relayNumber,
                            },
                            {
                                value: 2,
                                label: /* 号码池 */ UdeskLocales['current'].components
                                    .massagePushConfiguration.otherPush.components
                                    .callingRobotConfig.index.numberPool,
                            },
                        ]}
                        placeholder={
                            /* 请选择 */ UdeskLocales['current'].components.massagePushConfiguration
                                .otherPush.components.callingRobotConfig.index.pleaseSelect
                        }
                        style={{ width: 250 }}
                    />
                </div>
            </div>

            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    <Ellipsis
                        text={
                            /* 主叫号码值 */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.callingNumberValue
                        }
                    />
                </div>
                <div className="massage-push-configuration-row-content">
                    <Input
                        type="number"
                        value={value?.spnumberValue}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                spnumberValue: e.target.value ? Number(e.target.value) : undefined,
                            })
                        }
                        maxLength={200}
                        placeholder={
                            /* 请输入，仅限int */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.pleaseEnterIntOnly
                        }
                        style={{ width: 250 }}
                    />
                </div>
            </div>

            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    <Ellipsis
                        text={
                            /* 联系人列表ID */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.contactListID
                        }
                    />
                </div>
                <div className="massage-push-configuration-row-content">
                    <Input
                        type="number"
                        value={value?.taskContactBatchId}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                taskContactBatchId: e.target.value
                                    ? Number(e.target.value)
                                    : undefined,
                            })
                        }
                        maxLength={200}
                        placeholder={
                            /* 请输入，仅限int */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.pleaseEnterIntOnly
                        }
                        style={{ width: 250 }}
                    />
                </div>
            </div>

            <div className="massage-push-configuration-row">
                <div className="massage-push-configuration-row-label">
                    <Ellipsis
                        text={
                            /* 工作时间ID */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.workingTimeID
                        }
                    />
                </div>
                <div className="massage-push-configuration-row-content">
                    <Input
                        type="number"
                        value={value?.workTimeId}
                        onChange={(e) =>
                            onChange?.({
                                ...value,
                                workTimeId: e.target.value ? Number(e.target.value) : undefined,
                            })
                        }
                        maxLength={200}
                        placeholder={
                            /* 请输入，仅限int */ UdeskLocales['current'].components
                                .massagePushConfiguration.otherPush.components.callingRobotConfig
                                .index.pleaseEnterIntOnly
                        }
                        style={{ width: 250 }}
                    />
                </div>
            </div>
        </div>
    );
});

export default Template;
